type AuditLogRow = {
  id?: string | null;
  timestamp?: string | null;
  user?: string | null;
  email?: string | null;
  section?: string | null;
  region?: string | null;
  details?: string | null;
  note?: string | null;
};

const HEADERS: (keyof AuditLogRow)[] = [
  "id",
  "timestamp",
  "user",
  "email",
  "section",
  "region",
  "details",
  "note",
];

const escapeCsvValue = (value: unknown): string =>
  `"${String(value ?? "").replace(/"/g, '""')}"`;

const toCsv = (rows: AuditLogRow[]): string => {
  const header = HEADERS.join(",");
  const lines = rows.map(row =>
    HEADERS.map(key => escapeCsvValue(row[key])).join(","),
  );
  return [header, ...lines].join("\r\n");
};

export const exportAuditLogCsv = (rows: AuditLogRow[], filename: string) => {
  const bom = "\uFEFF";
  const blob = new Blob([bom + toCsv(rows)], {
    type: "text/csv;charset=utf-8;",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `${filename}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
